import { MapPin, Building2, Users, Truck, Sparkles } from "lucide-react";
import IndiaMap from "@/components/IndiaMap";

const PARTNERS = [
  { icon: Building2, label: "Workshops", value: "12,000+", color: "#003DA5" },
  { icon: Users, label: "Surveyors", value: "350+", color: "#00A86B" },
  { icon: Truck, label: "Tow Partners", value: "250+", color: "#FF7A00" },
  { icon: Sparkles, label: "Claim Experts", value: "120+", color: "#3B82F6" },
];

export default function PartnerNetwork() {
  return (
    <div className="min-h-[calc(100vh-4rem)] bg-[#F8FAFC] py-12" data-testid="partners-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 max-w-2xl mx-auto">
          <span className="inline-block px-3 py-1 rounded-full bg-[#FFF2E5] text-[#FF7A00] text-[10px] font-bold uppercase tracking-[0.2em] mb-3">
            Partner Network
          </span>
          <h1 className="font-heading text-3xl sm:text-5xl font-extrabold tracking-tight text-slate-900">
            Across India. Always on.
          </h1>
          <p className="text-slate-600 mt-2">Our network of workshops, surveyors and tow partners powers fast settlements in 100+ cities.</p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
          {PARTNERS.map((p) => {
            const Icon = p.icon;
            return (
              <div key={p.label} className="bg-white rounded-2xl border border-slate-200 p-6 text-center hover-lift" data-testid={`partner-stat-${p.label.toLowerCase().replace(/\s+/g, "-")}`}>
                <div className="w-12 h-12 rounded-xl mx-auto flex items-center justify-center mb-3" style={{ background: `${p.color}15`, color: p.color }}>
                  <Icon className="w-6 h-6" />
                </div>
                <div className="font-heading font-black text-3xl text-slate-900">{p.value}</div>
                <div className="text-xs font-bold uppercase tracking-wider text-slate-500 mt-1">{p.label}</div>
              </div>
            );
          })}
        </div>

        <div className="grid lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 bg-white rounded-2xl border border-slate-200 p-6">
            <div className="flex items-center justify-between mb-4">
              <h2 className="font-heading font-bold text-xl text-slate-900">Network density across India</h2>
              <div className="hidden sm:flex items-center gap-2 text-xs text-slate-500">
                <MapPin className="w-3.5 h-3.5 text-[#FF7A00]" /> Live workshop coverage
              </div>
            </div>
            <IndiaMap />
          </div>

          <div className="space-y-6">
            <div className="bg-gradient-to-br from-[#003DA5] to-[#0050D1] rounded-2xl p-6 text-white">
              <Sparkles className="w-7 h-7 mb-2" />
              <h2 className="font-heading font-bold text-xl">Become a partner</h2>
              <p className="text-sm opacity-90 mt-1">Join our growing network of workshops, surveyors and tow operators.</p>
              <ul className="mt-4 text-sm space-y-2 opacity-90">
                <li>✓ Steady claim volume</li>
                <li>✓ Fast invoice settlement</li>
                <li>✓ Marketing & lead support</li>
              </ul>
              <a href="mailto:partners@myinsuranceclaim.in" className="mt-5 inline-block bg-white text-[#003DA5] rounded-lg px-4 py-2 text-sm font-semibold" data-testid="partner-apply">Apply now →</a>
            </div>

            <div className="bg-white rounded-2xl border border-slate-200 p-6">
              <h3 className="font-heading font-bold text-slate-900 mb-3">Coverage at a glance</h3>
              <ul className="text-sm space-y-2.5">
                <li className="flex justify-between"><span className="text-slate-600">Tier-1 metros</span><span className="font-bold text-slate-900">8</span></li>
                <li className="flex justify-between"><span className="text-slate-600">Tier-2 cities</span><span className="font-bold text-slate-900">35</span></li>
                <li className="flex justify-between"><span className="text-slate-600">Tier-3 & beyond</span><span className="font-bold text-slate-900">57+</span></li>
                <li className="flex justify-between border-t border-slate-100 pt-2.5"><span className="text-slate-600 font-semibold">Total cities</span><span className="font-bold text-[#003DA5]">100+</span></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
